import React from 'react';

import CInputField from './cInputField';

import * as validationHelper from '../../../helpers/validationHelper';

import { EMAIL_INVALID_MESSAGE } from '../../../constants/errorMessages';

class EmailField extends React.Component {
    state = {
        isEmailExists: true,
    }

    onChange = (event, { value }) => {
        this.props.onChange(value.trim());
    }

    onEmailBlur = () => {
        if (this.props.value && validationHelper.isEmailValid(this.props.value)) {
            validationHelper.isEmailExists(
                this.props.value,
                isValid => (this.setState({ isEmailExists: isValid }))
            );
        }
    }

    render() {
        const { key, value, label, id, validation, inputSub, hidden } = this.props;
        const emailErrorMessage = value && !this.state.isEmailExists ? EMAIL_INVALID_MESSAGE : "";

        return (
            <CInputField error={value && !this.state.isEmailExists}
                errorMessage={emailErrorMessage}
                key={key}
                id={id}
                label={label}
                value={value}
                onChange={this.onChange}
                validation={validation}
                onBlur={this.onEmailBlur}
                inputSub={inputSub}
                hidden={hidden} />
        );
    }
}

export default EmailField;